var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mose",class:_vm.is_http_type == true ? 'show' : ''},[_c('div',{staticClass:"url"},[_c('p',[_vm._v("\n      请使用“https://v.jingjiribao.cn/newcommunity/#/login?state=1”访问网站\n    ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://v.jingjiribao.cn/newcommunity/#/login?state=1"}},[_vm._v(_vm._s(_vm.count)+"后自动跳转")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26df5310","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/is_http.vue
// module id = null
// module chunks = 